import { GetCompanyUserGroupsResponse } from '@upright/common/iam/access/user-groups/api-types';
import { isProperlyFormattedCompanyId } from '@upright/common/model/input/companies/is-valid-company-id';
import { fetchOrThrow } from '@upright/ui/api/common/fetchers/fetch-or-throw';
import { useQuery } from '@tanstack/react-query';

async function getCompanyUserGroups(companyId: string | undefined) {
  if (!companyId) throw Error(`Cannot fetch without a company id`);
  return await fetchOrThrow<GetCompanyUserGroupsResponse>(`/company/${companyId}/user-groups`, 'GET');
}

export function useGetCompanyUserGroups(companyId: string | undefined) {
  return useQuery({
    queryKey: ['getCompanyUserGroups', companyId],

    queryFn: async () => {
      return await getCompanyUserGroups(companyId);
    },

    enabled: !!companyId && isProperlyFormattedCompanyId(companyId),
  });
}
